import { render, staticRenderFns } from "./guanliansiji.vue?vue&type=template&id=32d6ad9f&scoped=true&"
import script from "./guanliansiji.vue?vue&type=script&lang=js&"
export * from "./guanliansiji.vue?vue&type=script&lang=js&"
import style0 from "./guanliansiji.vue?vue&type=style&index=0&id=32d6ad9f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d6ad9f",
  null
  
)

export default component.exports